var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
//import { useBranchesPatch  } from "../../fnx/branches/branchesPatch";
//import { useBranchesPost  } from "../../fnx/branches/branchesPost";
import { deleteEntityClearData } from "../../store/delete/actions";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { useProjectTypeGetAll } from "../../fnx/projectType/projectTypeGetAll";
import { showErrorToast } from "../../fnx/showError";
import { useProjectTypePost } from "../../fnx/projectType/projectTypePost";
import { useProjectTypePatch } from "../../fnx/projectType/projectTypePatch";
import { useTranslation } from "react-i18next";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ProjectTypesAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState([]), listProjectTypes = _a[0], setListProjectTypes = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(false), triggerPost = _c[0], setTriggerPost = _c[1];
    var _d = useState(false), triggerPatch = _d[0], setTriggerPatch = _d[1];
    var _e = useState(""), idProjectType = _e[0], setIdProjectType = _e[1];
    var _f = useState({
        data: {
            clientId: "",
        },
    }), bodyRequest = _f[0], setBodyRequest = _f[1];
    var _g = useState(false), openModal = _g[0], setOpenModal = _g[1];
    var _h = useState(false), openModalConfirm = _h[0], setOpenModalConfirm = _h[1];
    var _j = useState(false), openModalCloneConfirm = _j[0], setOpenModalCloneConfirm = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = useState(false), isUpdate = _k[0], setIsUpdate = _k[1];
    var _l = useState(null), itemModal = _l[0], setitemModal = _l[1];
    var _m = useState({
        Id: "",
        Description: "",
    }), dataForm = _m[0], setDataForm = _m[1];
    var _o = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _o[0], setSeeToast = _o[1];
    var _p = useProjectTypeGetAll(trigger, clientId), responseProjectType = _p.responseProjectType, errorProjectType = _p.errorProjectType, loadingProjectType = _p.loadingProjectType;
    var _q = useProjectTypePost(triggerPost, bodyRequest), responseProjectTypePost = _q.responseProjectTypePost, errorProjectTypePost = _q.errorProjectTypePost, loadingProjectTypePost = _q.loadingProjectTypePost;
    var _r = useProjectTypePatch(triggerPatch, bodyRequest, idProjectType), responseProjectTypePatch = _r.responseProjectTypePatch, errorProjectTypePatch = _r.errorProjectTypePatch, loadingProjectTypePatch = _r.loadingProjectTypePatch;
    var _s = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _s.responseDeleteEntity, loadingDeleteEntity = _s.loadingDeleteEntity, errorDeleteEntity = _s.errorDeleteEntity;
    var callProjectTypes = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callProjectTypes();
    }, []);
    var callProjectTypePost = function () {
        setTriggerPost(!triggerPost);
    };
    var callProjectTypePatch = function () {
        setTriggerPatch(!triggerPatch);
    };
    useEffect(function () {
        if (responseProjectType && (responseProjectType === null || responseProjectType === void 0 ? void 0 : responseProjectType.length) > 0) {
            var listProjectTypes_1 = responseProjectType.map(function (item) { return ({
                id: item.id,
                title: item.description,
                clientId: item.clientId,
            }); });
            setListProjectTypes(listProjectTypes_1);
            setTrigger(false);
        }
    }, [responseProjectType]);
    /*Valida respuesta cuando ya se inserto el registro*/
    useEffect(function () {
        setTriggerPost(false);
        if (responseProjectTypePost) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
        }
        callProjectTypes();
    }, [responseProjectTypePost]);
    /*Valida respuesta cuando ya se actualizo el registro*/
    useEffect(function () {
        setTriggerPost(false);
        if (responseProjectTypePatch) {
            setSeeToast({
                show: true,
                message: "Registro actualizado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
        }
        callProjectTypes();
    }, [responseProjectTypePatch]);
    /*Muestra si tubo errores el GET ALL de Tipo de Proyectos*/
    useEffect(function () {
        if (errorProjectType) {
            showErrorToast(errorProjectType, setSeeToast, t);
        }
    }, [errorProjectType]);
    /*Muestra si tubo errores el POST de Tipo de Proyectos*/
    useEffect(function () {
        if (errorProjectTypePost) {
            showErrorToast(errorProjectTypePost, setSeeToast, t);
        }
    }, [errorProjectTypePost]);
    /*Muestra si tubo errores el Patch de Tipo de Proyectos*/
    useEffect(function () {
        if (errorProjectTypePatch) {
            showErrorToast(errorProjectTypePatch, setSeeToast, t);
        }
    }, [errorProjectTypePatch]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { Id: row.id, Description: row.title, clientId: clientId }));
    };
    /*Submit para actualizar o agregar un registro*/
    var handleSubmitProjectType = function (dataProject) {
        if (isUpdate) {
            /*Se llena la informacion al momento de acutalizar*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    description: dataProject.Description,
                },
            });
            // Se asigna el id del ProjectType para a actualizar
            setIdProjectType(dataForm.Id);
            /*Llamda al FNX para actualizar PATCH*/
            callProjectTypePatch();
            // setAvatarFile(file);
        }
        else {
            /*Se procede a crear un nuevo Registro*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    description: dataProject.Description,
                },
            });
            // setAvatarFile(file);
            /*Llamada al FNX para crear Registro*/
            callProjectTypePost();
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { Id: "", Description: "", clientId: "" }));
    };
    var handleOnClickButtonOptionsDropdown = function (opt, item) {
        if (opt.id === "1") {
            // Opcion Editar
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(item);
        }
        else if (opt.id === "2") {
            // Opcion eliminar
            // setitemModal(item);
            // setOpenModalConfirm(true);
            setSeeToast({
                show: true,
                message: "Operación no permitida!",
                type: typeAlert.warning,
            });
            setOpenModal(false);
        }
        else if (opt.id === "3") {
            setitemModal(item);
            setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    /*Api que se ejecuta cuando el catalogo tiene la opcion
     * para eliminar registros*/
    var handleDelete = function () {
        setSeeToast({
            show: true,
            message: "Operación no permitida!",
            type: typeAlert.warning,
        });
        setOpenModal(false);
    };
    var handleClone = function () { };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Tipos de Proyectos", projectTypeTitle: isUpdate ? "Modificar Tipo Proyecto" : "Agregar Tipo Proyecto", list: listProjectTypes, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onSaveData: handleSubmitProjectType, onClickAdd: handleOnClickAdd, onClickCancel: handleCloseModal, onClickButtonOptionsDropdown: function (opt, item) {
                    handleOnClickButtonOptionsDropdown(opt, item);
                } })] }));
};
export default ProjectTypesAdmin;
